import { FooterLottery } from "./footerLottery";

class FooterLotteryComponent {
  constructor() {
    this.init();
  }

  init() {
    FooterLottery.init();
  }
}
new FooterLotteryComponent();
